/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppEntriesRouteImport } from './routes/_app/entries'
import { Route as AppCategoriesRouteImport } from './routes/_app/categories'
import { Route as AppEntriesIdRouteImport } from './routes/_app/entries.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppEntriesRoute = AppEntriesRouteImport.update({
  id: '/entries',
  path: '/entries',
  getParentRoute: () => AppRoute,
} as any)
const AppCategoriesRoute = AppCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AppRoute,
} as any)
const AppEntriesIdRoute = AppEntriesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppEntriesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/categories': typeof AppCategoriesRoute
  '/entries': typeof AppEntriesRouteWithChildren
  '/settings': typeof AppSettingsRoute
  '/entries/$id': typeof AppEntriesIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/categories': typeof AppCategoriesRoute
  '/entries': typeof AppEntriesRouteWithChildren
  '/settings': typeof AppSettingsRoute
  '/': typeof AppIndexRoute
  '/entries/$id': typeof AppEntriesIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/categories': typeof AppCategoriesRoute
  '/_app/entries': typeof AppEntriesRouteWithChildren
  '/_app/settings': typeof AppSettingsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/entries/$id': typeof AppEntriesIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/categories'
    | '/entries'
    | '/settings'
    | '/entries/$id'
  fileRoutesByTo: FileRoutesByTo
  to: '/login' | '/categories' | '/entries' | '/settings' | '/' | '/entries/$id'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/categories'
    | '/_app/entries'
    | '/_app/settings'
    | '/_app/'
    | '/_app/entries/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/entries': {
      id: '/_app/entries'
      path: '/entries'
      fullPath: '/entries'
      preLoaderRoute: typeof AppEntriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/categories': {
      id: '/_app/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AppCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/entries/$id': {
      id: '/_app/entries/$id'
      path: '/$id'
      fullPath: '/entries/$id'
      preLoaderRoute: typeof AppEntriesIdRouteImport
      parentRoute: typeof AppEntriesRoute
    }
  }
}

interface AppEntriesRouteChildren {
  AppEntriesIdRoute: typeof AppEntriesIdRoute
}

const AppEntriesRouteChildren: AppEntriesRouteChildren = {
  AppEntriesIdRoute: AppEntriesIdRoute,
}

const AppEntriesRouteWithChildren = AppEntriesRoute._addFileChildren(
  AppEntriesRouteChildren,
)

interface AppRouteChildren {
  AppCategoriesRoute: typeof AppCategoriesRoute
  AppEntriesRoute: typeof AppEntriesRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCategoriesRoute: AppCategoriesRoute,
  AppEntriesRoute: AppEntriesRouteWithChildren,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
